import type { Asset, AssetReservation } from "@/domains/assets/api/types";

const ANTWERPEN_DEPOT = {
  address: "Politieplein 1, 2600 Antwerpen-Berchem",
  district: "Berchem",
  lat: 51.193,
  lng: 4.421,
};

export const SEED_ASSETS: ReadonlyArray<Asset> = [
  {
    id: "ast-c-001",
    number: "MC-001",
    type: "camera",
    name: "Mobiele camera Hikvision DS-2DE",
    serialNumber: "HK-2401-001",
    status: "inUse",
    currentLocation: {
      address: "De Coninckplein 1, 2060 Antwerpen",
      district: "Antwerpen-Noord",
      lat: 51.224,
      lng: 4.41,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-02",
  },
  {
    id: "ast-c-002",
    number: "MC-002",
    type: "camera",
    name: "Mobiele camera Hikvision DS-2DE",
    serialNumber: "HK-2401-002",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-08",
  },
  {
    id: "ast-c-003",
    number: "MC-003",
    type: "camera",
    name: "Mobiele camera Axis Q6125",
    serialNumber: "AX-2308-003",
    status: "outOfService",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-04-22",
    note: "Voeding defect — wacht op herstelling",
  },
  {
    id: "ast-c-004",
    number: "MC-004",
    type: "camera",
    name: "Mobiele camera Axis Q6125",
    serialNumber: "AX-2308-004",
    status: "inUse",
    currentLocation: {
      address: "Groenplaats, 2000 Antwerpen",
      district: "Antwerpen-Centrum",
      lat: 51.219,
      lng: 4.401,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-05",
  },
  {
    id: "ast-c-005",
    number: "MC-005",
    type: "camera",
    name: "Mobiele camera Hikvision DS-2DE",
    serialNumber: "HK-2401-005",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-10",
  },
  {
    id: "ast-c-006",
    number: "MC-006",
    type: "camera",
    name: "Mobiele camera Hikvision DS-2DE",
    serialNumber: "HK-2401-006",
    status: "maintenance",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-01",
    note: "Periodieke firmware update",
  },
  {
    id: "ast-c-007",
    number: "MC-007",
    type: "camera",
    name: "Mobiele camera Bosch MIC 7000i",
    serialNumber: "BO-2402-007",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-09",
  },
  {
    id: "ast-c-008",
    number: "MC-008",
    type: "camera",
    name: "Mobiele camera Bosch MIC 7000i",
    serialNumber: "BO-2402-008",
    status: "inUse",
    currentLocation: {
      address: "Sint-Jansvliet 19, 2000 Antwerpen",
      district: "Antwerpen-Zuid",
      lat: 51.217,
      lng: 4.397,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-04",
  },
  {
    id: "ast-mt-001",
    number: "MT-001",
    type: "mobileTree",
    name: "Mobile Tree Aluvision MT-3",
    serialNumber: "AV-MT3-001",
    status: "inUse",
    currentLocation: {
      address: "Operaplein, 2018 Antwerpen",
      district: "Antwerpen-Centrum",
      lat: 51.215,
      lng: 4.413,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-03",
  },
  {
    id: "ast-mt-002",
    number: "MT-002",
    type: "mobileTree",
    name: "Mobile Tree Aluvision MT-3",
    serialNumber: "AV-MT3-002",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-09",
  },
  {
    id: "ast-mt-003",
    number: "MT-003",
    type: "mobileTree",
    name: "Mobile Tree Aluvision MT-5",
    serialNumber: "AV-MT5-003",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-07",
  },
  {
    id: "ast-mt-004",
    number: "MT-004",
    type: "mobileTree",
    name: "Mobile Tree Aluvision MT-5",
    serialNumber: "AV-MT5-004",
    status: "outOfService",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-04-18",
    note: "Stabilisatiepoot beschadigd",
  },
  {
    id: "ast-cc-001",
    number: "CC-001",
    type: "camcar",
    name: "Camcar Mercedes Sprinter",
    serialNumber: "1-ABC-123",
    status: "inUse",
    currentLocation: {
      address: "Sportpaleis, 2140 Borgerhout",
      district: "Borgerhout",
      lat: 51.226,
      lng: 4.444,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-06",
  },
  {
    id: "ast-cc-002",
    number: "CC-002",
    type: "camcar",
    name: "Camcar Mercedes Sprinter",
    serialNumber: "1-ABC-456",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-10",
  },
  {
    id: "ast-cc-003",
    number: "CC-003",
    type: "camcar",
    name: "Camcar Volkswagen Crafter",
    serialNumber: "1-DEF-789",
    status: "maintenance",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-04-30",
    note: "Banden vervangen + APK keuring",
  },
  {
    id: "ast-bp-001",
    number: "BP-001",
    type: "batteryPack",
    name: "Battery pack 5kWh",
    serialNumber: "BP-5K-001",
    status: "inUse",
    currentLocation: {
      address: "De Coninckplein 1, 2060 Antwerpen",
      district: "Antwerpen-Noord",
      lat: 51.224,
      lng: 4.41,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-02",
  },
  {
    id: "ast-bp-002",
    number: "BP-002",
    type: "batteryPack",
    name: "Battery pack 5kWh",
    serialNumber: "BP-5K-002",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-08",
  },
  {
    id: "ast-bp-003",
    number: "BP-003",
    type: "batteryPack",
    name: "Battery pack 10kWh",
    serialNumber: "BP-10K-003",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-09",
  },
  {
    id: "ast-bp-004",
    number: "BP-004",
    type: "batteryPack",
    name: "Battery pack 10kWh",
    serialNumber: "BP-10K-004",
    status: "inUse",
    currentLocation: {
      address: "Operaplein, 2018 Antwerpen",
      district: "Antwerpen-Centrum",
      lat: 51.215,
      lng: 4.413,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-03",
  },
  {
    id: "ast-tr-001",
    number: "TR-001",
    type: "trailer",
    name: "Camera trailer ANPR",
    serialNumber: "TR-ANPR-001",
    status: "inUse",
    currentLocation: {
      address: "Singel 25, 2018 Antwerpen",
      district: "Antwerpen-Zuid",
      lat: 51.207,
      lng: 4.412,
    },
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-01",
  },
  {
    id: "ast-tr-002",
    number: "TR-002",
    type: "trailer",
    name: "Camera trailer ANPR",
    serialNumber: "TR-ANPR-002",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-09",
  },
  {
    id: "ast-tr-003",
    number: "TR-003",
    type: "trailer",
    name: "Camera trailer overzicht",
    serialNumber: "TR-OV-003",
    status: "available",
    homeBase: ANTWERPEN_DEPOT,
    lastCheck: "2026-05-07",
  },
];

export const SEED_RESERVATIONS: ReadonlyArray<AssetReservation> = [
  {
    id: "res-001",
    assetId: "ast-c-001",
    caseId: "case-9214",
    startDate: "2026-05-05",
    endDate: "2026-05-19",
  },
  {
    id: "res-002",
    assetId: "ast-bp-001",
    caseId: "case-9214",
    startDate: "2026-05-05",
    endDate: "2026-05-19",
  },
  {
    id: "res-003",
    assetId: "ast-c-004",
    caseId: "case-9221",
    startDate: "2026-05-08",
    endDate: "2026-05-15",
  },
  {
    id: "res-004",
    assetId: "ast-c-008",
    caseId: "case-9223",
    startDate: "2026-05-04",
    endDate: "2026-05-18",
  },
  {
    id: "res-005",
    assetId: "ast-mt-001",
    caseId: "case-9225",
    startDate: "2026-05-09",
    endDate: "2026-05-23",
  },
  {
    id: "res-006",
    assetId: "ast-bp-004",
    caseId: "case-9225",
    startDate: "2026-05-09",
    endDate: "2026-05-23",
  },
  {
    id: "res-007",
    assetId: "ast-cc-001",
    caseId: "case-9227",
    startDate: "2026-05-11",
    endDate: "2026-05-13",
  },
  {
    id: "res-008",
    assetId: "ast-tr-001",
    caseId: "case-9229",
    startDate: "2026-05-01",
    endDate: "2026-05-15",
  },

  // Historische reservaties (Jan-Apr 2026) — voor realistische utilization-cijfers.
  // Mobiele camera's — hoge bezettingsgraad
  { id: "res-009", assetId: "ast-c-001", caseId: "case-9015", startDate: "2026-01-08", endDate: "2026-02-02" },
  { id: "res-010", assetId: "ast-c-001", caseId: "case-9032", startDate: "2026-02-14", endDate: "2026-03-08" },
  { id: "res-011", assetId: "ast-c-001", caseId: "case-9058", startDate: "2026-03-24", endDate: "2026-04-17" },

  { id: "res-012", assetId: "ast-c-002", caseId: "case-9011", startDate: "2026-01-04", endDate: "2026-01-29" },
  { id: "res-013", assetId: "ast-c-002", caseId: "case-9028", startDate: "2026-02-10", endDate: "2026-03-05" },
  { id: "res-014", assetId: "ast-c-002", caseId: "case-9055", startDate: "2026-03-18", endDate: "2026-04-12" },
  { id: "res-015", assetId: "ast-c-002", caseId: "case-9088", startDate: "2026-04-22", endDate: "2026-05-09" },

  { id: "res-016", assetId: "ast-c-003", caseId: "case-9013", startDate: "2026-01-06", endDate: "2026-01-31" },
  { id: "res-017", assetId: "ast-c-003", caseId: "case-9034", startDate: "2026-02-16", endDate: "2026-03-12" },
  { id: "res-018", assetId: "ast-c-003", caseId: "case-9057", startDate: "2026-03-22", endDate: "2026-04-16" },
  { id: "res-019", assetId: "ast-c-003", caseId: "case-9092", startDate: "2026-04-28", endDate: "2026-05-11" },

  { id: "res-020", assetId: "ast-c-004", caseId: "case-9020", startDate: "2026-01-18", endDate: "2026-02-11" },
  { id: "res-021", assetId: "ast-c-004", caseId: "case-9038", startDate: "2026-02-25", endDate: "2026-03-18" },
  { id: "res-022", assetId: "ast-c-004", caseId: "case-9072", startDate: "2026-04-03", endDate: "2026-04-28" },

  { id: "res-023", assetId: "ast-c-005", caseId: "case-9018", startDate: "2026-01-12", endDate: "2026-02-07" },
  { id: "res-024", assetId: "ast-c-005", caseId: "case-9042", startDate: "2026-03-01", endDate: "2026-03-23" },
  { id: "res-025", assetId: "ast-c-005", caseId: "case-9078", startDate: "2026-04-08", endDate: "2026-05-01" },

  { id: "res-026", assetId: "ast-c-006", caseId: "case-9023", startDate: "2026-01-20", endDate: "2026-02-14" },
  { id: "res-027", assetId: "ast-c-006", caseId: "case-9050", startDate: "2026-03-10", endDate: "2026-04-04" },
  { id: "res-028", assetId: "ast-c-006", caseId: "case-9085", startDate: "2026-04-18", endDate: "2026-05-10" },

  { id: "res-029", assetId: "ast-c-007", caseId: "case-9030", startDate: "2026-02-05", endDate: "2026-03-01" },
  { id: "res-030", assetId: "ast-c-007", caseId: "case-9083", startDate: "2026-04-15", endDate: "2026-05-10" },

  { id: "res-031", assetId: "ast-c-008", caseId: "case-9008", startDate: "2026-01-02", endDate: "2026-01-26" },
  { id: "res-032", assetId: "ast-c-008", caseId: "case-9033", startDate: "2026-02-12", endDate: "2026-03-08" },
  { id: "res-033", assetId: "ast-c-008", caseId: "case-9056", startDate: "2026-03-20", endDate: "2026-04-14" },

  // Mobile trees — middelmatige bezetting (event-gebonden)
  { id: "res-034", assetId: "ast-mt-001", caseId: "case-9036", startDate: "2026-02-18", endDate: "2026-03-12" },
  { id: "res-035", assetId: "ast-mt-001", caseId: "case-9075", startDate: "2026-04-05", endDate: "2026-04-28" },

  { id: "res-036", assetId: "ast-mt-002", caseId: "case-9024", startDate: "2026-01-22", endDate: "2026-02-14" },
  { id: "res-037", assetId: "ast-mt-002", caseId: "case-9048", startDate: "2026-03-08", endDate: "2026-03-29" },

  { id: "res-038", assetId: "ast-mt-003", caseId: "case-9026", startDate: "2026-02-01", endDate: "2026-02-22" },
  { id: "res-039", assetId: "ast-mt-003", caseId: "case-9070", startDate: "2026-04-01", endDate: "2026-04-22" },

  { id: "res-040", assetId: "ast-mt-004", caseId: "case-9053", startDate: "2026-03-12", endDate: "2026-04-02" },

  // Camcars — lage bezetting (alleen voor concerten/events, korte duur)
  { id: "res-041", assetId: "ast-cc-001", caseId: "case-9031", startDate: "2026-02-14", endDate: "2026-02-16" },
  { id: "res-042", assetId: "ast-cc-001", caseId: "case-9046", startDate: "2026-03-07", endDate: "2026-03-09" },
  { id: "res-043", assetId: "ast-cc-001", caseId: "case-9080", startDate: "2026-04-18", endDate: "2026-04-21" },

  { id: "res-044", assetId: "ast-cc-002", caseId: "case-9051", startDate: "2026-03-14", endDate: "2026-03-15" },
  { id: "res-045", assetId: "ast-cc-002", caseId: "case-9086", startDate: "2026-04-25", endDate: "2026-04-27" },

  { id: "res-046", assetId: "ast-cc-003", caseId: "case-9091", startDate: "2026-05-02", endDate: "2026-05-04" },

  // Battery packs — vaak gekoppeld aan camera-inzet
  { id: "res-047", assetId: "ast-bp-001", caseId: "case-9015", startDate: "2026-01-08", endDate: "2026-02-02" },
  { id: "res-048", assetId: "ast-bp-001", caseId: "case-9058", startDate: "2026-03-24", endDate: "2026-04-17" },

  { id: "res-049", assetId: "ast-bp-002", caseId: "case-9018", startDate: "2026-01-12", endDate: "2026-02-09" },
  { id: "res-050", assetId: "ast-bp-002", caseId: "case-9088", startDate: "2026-04-22", endDate: "2026-05-09" },

  { id: "res-051", assetId: "ast-bp-003", caseId: "case-9030", startDate: "2026-02-05", endDate: "2026-03-01" },
  { id: "res-052", assetId: "ast-bp-003", caseId: "case-9083", startDate: "2026-04-15", endDate: "2026-05-09" },

  { id: "res-053", assetId: "ast-bp-004", caseId: "case-9042", startDate: "2026-03-01", endDate: "2026-03-23" },

  // Trailers — middelmatige bezetting (lange duurtijd per inzet)
  { id: "res-054", assetId: "ast-tr-001", caseId: "case-9027", startDate: "2026-02-01", endDate: "2026-02-28" },
  { id: "res-055", assetId: "ast-tr-001", caseId: "case-9054", startDate: "2026-03-15", endDate: "2026-04-05" },

  { id: "res-056", assetId: "ast-tr-002", caseId: "case-9017", startDate: "2026-01-10", endDate: "2026-02-08" },
  { id: "res-057", assetId: "ast-tr-002", caseId: "case-9056", startDate: "2026-03-20", endDate: "2026-04-18" },

  { id: "res-058", assetId: "ast-tr-003", caseId: "case-9070", startDate: "2026-04-01", endDate: "2026-04-30" },
];
